import React from 'react';
import IndustryTemplate, { IndustryConfig } from './IndustryTemplate';

const config: IndustryConfig = {
  slug: 'restaurants',
  label: 'Restaurants',
  heroTitle: 'Monetize Your',
  heroDim: 'Restaurant Data Assets',
  heroSubtitle:
    'Restaurants generate rich, high-frequency data — orders, menus, reservation patterns, and customer preferences. Efficient helps you license this data to AI companies building the next generation of food, logistics, and consumer tools.',
  heroImage: '/restaurant-sign.jpg',
  heroImageAlt: 'Restaurant open sign',
  processSteps: [
    {
      num: '01',
      icon: '/step_door.svg',
      title: 'Data Assessment',
      desc: 'We review your POS records, menu data, and reservation logs to identify what\'s marketable to AI buyers.',
    },
    {
      num: '02',
      icon: '/step_onboard.svg',
      title: 'Qualification',
      desc: 'We match your dataset to active buyers in the food, delivery, and consumer AI markets and provide a transparent quote.',
    },
    {
      num: '03',
      icon: '/step_extract.svg',
      title: 'Preparation',
      desc: 'We structure and anonymize your data, ensuring full compliance before delivery to any buyer.',
    },
    {
      num: '04',
      icon: '/step_paid.svg',
      title: 'Revenue Recognition',
      desc: 'You earn a revenue share on every transaction — your daily operations data becomes a recurring income asset.',
    },
  ],
  valueHeading: 'What restaurant data can be monetized',
  valueProps: [
    {
      title: 'Order & Menu Data',
      desc: 'What your guests order — and how your menu is priced — reflects years of real operational knowledge about what works in your kitchen and your market.',
    },
    {
      title: 'Reservation & Traffic Patterns',
      desc: 'The rhythm of your business — when guests arrive, how long they stay, when demand peaks — is the kind of insight that only becomes visible over time.',
    },
    {
      title: 'Customer Preferences',
      desc: 'Repeat order patterns and guest preferences reflect genuine loyalty and taste built through years of service — not survey data, but real behavior.',
    },
  ],
  aiAccelHeading: 'Run a tighter operation with AI on your side.',
  aiAccelPoints: [
    {
      title: 'Demand Forecasting & Prep Optimization',
      desc: 'AI models trained on your order history can predict covers by shift, reduce food waste, and help you staff more precisely.',
    },
    {
      title: 'Menu Engineering',
      desc: 'Identify your highest-margin, highest-velocity items and get AI-assisted recommendations for pricing adjustments and menu layout.',
    },
    {
      title: 'Guest Retention & Marketing',
      desc: 'Automatically identify lapsed guests, generate personalized offers, and measure what actually brings people back through the door.',
    },
  ],
  ctaHeading: 'Your POS data is a hidden asset',
  ctaBody:
    'Join our network of restaurant partners and create new revenue from order and menu data your business generates every day.',
};

export default function Restaurants() {
  return <IndustryTemplate config={config} />;
}
